<script setup>
import { useCanvas } from '@/composables/canvas';
import { onMounted, useTemplateRef } from 'vue';

const canvasStore = useCanvas()
const canvasElemRef = useTemplateRef("canvas")

onMounted(() => {
  canvasStore.setCanvasElement(canvasElemRef.value)
  canvasStore.addLines()
})


var log = [
  {
    test: 123
  }, {
    test: 123
  }, {
    test: 123
  }
]

let showLog = false

</script>

<template>
  <canvas ref="canvas"></canvas>
  <div class="log" v-if="showLog">
    <ul>
      <li v-for="l in log" :key="l">
        <pre>{{ JSON.stringify(l, null, 2) }}</pre>
      </li>
    </ul>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
canvas {
  background-color: rgba(227, 204, 166, 1);
  width: 100%;
  height: 100%;
}

.log {
  border: solid 3px red;
  width: 50%;


  ul {
    list-style: none;
    padding: var(--spacing-xs);

    li {
      padding: var(--spacing-xs);

      &:nth-child(even) {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

  }
}
</style>
